export const FILTER_TYPE_LABELS: Record<string, string> = {
  keyword: 'Keyword',
  hashtag: 'Hashtag',
  profile: 'Profile',
  gender: 'Gender',
  race: 'Race',
  age: 'Age',
  location: 'Location',
  // 'default' is intentionally not included here as it doesn't need a label
};
